import A from './types';
import startOfDay from 'date-fns/start_of_day';
import startOfMinute from 'date-fns/start_of_minute';

const initialState = {
  date: startOfDay(new Date()),
  minute: startOfMinute(new Date()),
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.NOW_DATE_CHANGED: {
      return {
        date: action.payload,
      };
    }
    case A.NOW_MINUTE_CHANGED: {
      return {
        minute: action.payload,
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/now/reducer.js